import type { ReduxState } from "model/state"
import { computeEffectiveFilterScope, computeHasTagOrAttributeFilter, type FilterScope } from "helpers/filter-scope"
import { selectCoreState } from "./select-core-state"

export function selectEffectiveFilterScopeForBenchmark(state: ReduxState, dashboardId: string, benchmark: unknown): FilterScope {
  const hasSimulatedTrades = (state.dashboard.trade[dashboardId]?.trades.length ?? 0) > 0
  const { filterScope, filter } = selectCoreState(state, dashboardId)
  return computeEffectiveFilterScope(filterScope, {
    hasBenchmark: Boolean(benchmark),
    hasSimulatedTrades,
    hasTagOrAttributeFilter: computeHasTagOrAttributeFilter(filter),
  })
}

export function selectEffectiveFilterScope(state: ReduxState, dashboardId: string): FilterScope {
  return selectEffectiveFilterScopeForBenchmark(state, dashboardId, selectCoreState(state, dashboardId).base)
}
